import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 1,
  class: "base-button-icon"
}
const _hoisted_3 = {
  key: 2,
  class: "base-button-icon"
}

import { computed, type Component } from 'vue'
import { Loader2 } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    type: { default: 'button' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    leftIcon: {},
    rightIcon: {}
  },
  setup(__props: any) {

const props = __props

const variantClass = computed(() => `base-button--${props.variant}`)
const sizeClass = computed(() => `base-button--${props.size}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    disabled: _ctx.disabled || _ctx.loading,
    class: _normalizeClass(["base-button", [variantClass.value, sizeClass.value, { 'is-loading': _ctx.loading, 'is-fullwidth': _ctx.fullWidth }]])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_unref(Loader2), {
          key: 0,
          class: "base-button-spinner"
        }))
      : _createCommentVNode("", true),
    (_ctx.leftIcon && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.leftIcon), { class: "h-5 w-5" }))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["base-button-text", { 'opacity-0': _ctx.loading }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_ctx.rightIcon && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.rightIcon), { class: "h-5 w-5" }))
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})